module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"change":"Change"}}')
  delete Component.options._Ctor
}
